import React from "react";
import { TextField, MenuItem } from "@mui/material";

import { motion } from "framer-motion";
import { cityLocalities, formVariant } from "../../utility/constains";

const CityLocalityFields = ({
  city,
  locality,
  handleCityChange,
  setLocality,
}) => (
  <motion.div
    className="flex flex-col md:flex-row gap-4"
    initial="hidden"
    animate="visible"
    custom={0}
    variants={formVariant}
  >
    <TextField
      select
      label="City"
      fullWidth
      value={city}
      onChange={handleCityChange}
      variant="outlined"
      InputProps={{
        className:
          "focus:ring-2 focus:ring-green-500 focus:border-green-500 hover:ring-green-600",
      }}
      InputLabelProps={{
        className: "text-green-600",
      }}
      SelectProps={{
        MenuProps: {
          PaperProps: {
            className: "noScrollbar",
          },
        },
      }}
    >
      {Object.keys(cityLocalities).map((cityName) => (
        <MenuItem
          key={cityName}
          value={cityName}
          className="hover:bg-green-500 hover:text-green-500"
        >
          {cityName}
        </MenuItem>
      ))}
    </TextField>

    <TextField
      select
      label="Locality"
      fullWidth
      value={locality}
      onChange={(e) => setLocality(e.target.value)}
      disabled={!city}
      variant="outlined"
      InputProps={{
        className:
          "focus:ring-2 focus:ring-green-500 focus:border-green-500 hover:ring-green-600",
      }}
      InputLabelProps={{
        className: "text-green-600",
      }}
      SelectProps={{
        MenuProps: {
          PaperProps: {
            className: "noScrollbar",
          },
        },
      }}
    >
      {city &&
        Object.keys(cityLocalities[city]).map((localityName) => (
          <MenuItem
            key={localityName}
            value={localityName}
            className="hover:bg-green-500 hover:text-green-500"
          >
            {localityName}
          </MenuItem>
        ))}
    </TextField>
  </motion.div>
);

export default CityLocalityFields;
